import { createContext } from "preact";

export const UrlContext = createContext();
